<template>
  <div class="container">
    <div class="title">
      <img class="img" src="../../assets/privacy/ic_cancel.png">
      <span class="text1">将 <span>{{ phone }}</span> 所绑定的账号注销</span>
      <div class="text2">为保证你的账号安全，在你提交的注销申请生效前，需同时满足以下条件：</div>
    </div>

    <div class="content">
      <div class="card">
        <div class="line">
          <div class="line-r"></div>
          <div class="text-r">账号内无较大余额（不超过1元，注销后余额自动清空）</div>
          <div class="check" @click="checkConfition">
            <div class="con">

              <img v-if="check" class="img" src="../../assets/privacy/ic_checked_b.png">
              <img v-else class="img" src="../../assets/privacy/ic_check_b.png">
              <div v-if="check" class="text">同意</div>
            </div>
          </div>
        </div>
      </div>

      <div class="card2 card">
        <div class="line">
          <div class="line-b"></div>
          <div class="text">账号内无未支付账单</div>
        </div>
        <div class="line">
          <div class="line-b"></div>
          <div class="text">账号内无免密支付账户</div>
        </div>
        <div class="line">
          <div class="line-b"></div>
          <div class="text">账号无实名认证</div>
        </div>
        <div class="line">
          <div class="line-b"></div>
          <div class="text">账号内无绑定设备</div>
        </div>
        <div class="line">
          <div class="line-b"></div>
          <div class="text">账号无管理权限</div>
        </div>
      </div>

      <div class="agreement">
        <img @click="checkRead" v-if="check2" class="img" src="../../assets/privacy/ic_checked_s.png">
        <img @click="checkRead" v-else class="img" src="../../assets/privacy/ic_check_s.png">
        我已阅读并同意
        <div @click="toAgreement" class="text">《用户注销协议》</div>
      </div>
    </div>

    <div class="bottom">
      <div v-if="check && check2" @click="toNext" class="btn">下一步</div>
      <div v-else class="btn-g">下一步</div>
    </div>
    <div class="hint">注销成功后将同步删除您的个人信息</div>
  </div>
</template>

<script>
export default {
  name: "CancelAccount",
  data() {
    return {
      phone: '',
      check: false,
      check2: false
    };
  },
  mounted() {
    this.phone = this.$route.query.phone + ''
    window.scroll(0,0)
  },
  methods: {
    checkConfition() {
      this.check = !this.check
    },
    checkRead() {
      this.check2 = !this.check2
    },
    toNext() {
      this.$router.push({
        path: "/cancelConditions",
        query: {phone: this.phone}
      });
    },
    toAgreement() {
      this.$router.push({
        path: "/agreement",
      });
    }
  }
}
</script>

<style scoped lang="less">
* {
  margin: 0;
  padding: 0;
}

.container {
  background-color: white;
  min-height: 100vh;
}

.title {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .img {
    width: 17.3vw;
    margin-top: 6.7vw;
  }

  .text1 {
    color: #333333;
    font-size: 18px;
    font-weight: 600;
    line-height: 18px;
    margin-top: 5.3vw;
  }

  .text2 {
    color: #999999;
    font-size: 14px;
    line-height: 26px;
    margin: 5.3vw 7vw 0 7vw;
  }
}

.content {
  display: flex;
  flex-direction: column;
  justify-content: center;

  margin: 5.3vw 7vw 5.3vw 7vw;

  .card {
    display: flex;
    flex-direction: column;
    width: 100%;
    box-sizing: border-box;
    padding: 5.3vw 7.2vw 0 5.3vw;
    box-shadow: 0 0.5vw 5.3vw 0 rgba(0, 0, 0, 0.05);
    border-radius: 16px;

    .line-r {
      width: 1.6vw;
      height: 1.6vw;
      border-radius: 1.6vw;
      background-color: #D83737;
      margin-top: 2.2vw;
    }

    .line-b {
      width: 1.6vw;
      height: 1.6vw;
      border-radius: 1.6vw;
      background-color: #286EFF;
      margin-top: 2.2vw;
    }

    .line {
      display: flex;
      margin-bottom: 5.3vw;
    }

    .text-r {
      width: 58.7vw;
      max-width: 58.7vw;
      font-size: 14px;
      line-height: 24px;
      color: #D83737;

      margin-left: 2.4vw;
    }

    .text {
      max-width: 58.7vw;
      font-size: 14px;
      line-height: 24px;
      color: #333333;

      margin-left: 2.4vw;
    }

    .check {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      flex: 1;
      margin-top: 1.9vw;

      .con {
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
      }

      .img {
        width: 5.3vw;
      }

      .text {
        color: #333333;
        font-size: 12px;
        line-height: 12px;
        margin: 0;
      }
    }
  }

  .card2 {
    margin-top: 2.7vw;
  }

  .agreement {
    display: flex;
    color: #999999;
    font-size: 12px;
    line-height: 12px;
    margin-top: 8vw;

    .img {
      width: 3.2vw;
      margin-right: 1.3vw;
    }

    .text {
      color: #286EFF;
    }
  }
}

.bottom {
  display: flex;
  align-items: center;
  justify-content: center;

  .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 54.7vw;
    height: 12vw;
    background-color: #286EFF;
    color: white;
    font-size: 16px;
    font-weight: 500;
    line-height: 16px;
    border-radius: 6.1vw;
    margin-bottom: 8vw;
  }

  .btn-g {
    background-color: #DADADA;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 54.7vw;
    height: 12vw;
    color: white;
    font-size: 16px;
    font-weight: 500;
    line-height: 16px;
    border-radius: 6.1vw;
    margin-bottom: 2vw;
  }
}
.hint{
    font-size: 14px;
    line-height: 24px;
    color: #D83737;
    text-align: center;
    margin-bottom: 8vw;
  }
</style>
